/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { GuardIcon } from '@atlaskit/logo';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	enforcementRow: {
		font: token('font.body.small'),
		color: token('color.text.subtle'),
		paddingBlock: token('space.150'),
	},
});

/**
 * Renders the enforcement row shown below the redacted message bubble:
 * GuardIcon + "Redacted by your organization".
 */
export const RedactionEnforcementMessage = ({
	alignInline = 'end',
}: {
	alignInline?: 'start' | 'end';
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Inline
			space="space.050"
			alignBlock="center"
			alignInline={alignInline}
			xcss={styles.enforcementRow}
		>
			<GuardIcon appearance="brand" shouldUseNewLogoDesign size="xsmall" />
			<Text>{formatMessage(messages.enforcementMessage)}</Text>
		</Inline>
	);
};
